import React, { Component } from "react";
import "./Body.scss";
import Header from "../Header/Header";
import Welcome from "../Welcome/Welcome";
import FormScreen from "../FormScreen/FormScreen";
import { usingQuizzesAPI } from "../Services/fetchService";

export default class Body extends Component {
    constructor() {
        super();
        this.state = {
            Screen: null,
            QuizQuestions: []
        }
    }
    componentDidMount() {
        usingQuizzesAPI.getQuestions(data => {
            this.setState({
                QuizQuestions: data
            })
        });
    }
    setScreen = Screen => {
        this.setState({
            Screen: Screen
        })
    }
    render() {
        return (
            <main className="section section-body">
                <div className="padding">
                    <div className="container">
                        <Header />
                        {this.state.Screen ? this.state.Screen : <div>
                            <Welcome />
                            <FormScreen
                                QuizQuestions={this.state.QuizQuestions}
                                setScreen={this.setScreen} />
                                <div className="right"></div>
                                <div className="left"></div>
                                
                        </div>}
                    </div>
                </div>
            </main>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Components/Body/Body.jsx